import { PARSE_URL_PARAMETERS, ADD_URL_PARAMETERS_FROM_COOKIE_HISTORY } from '../constants';

export default function trackingReducer(state = {}, action) {
  switch (action.type) {
    case PARSE_URL_PARAMETERS: {
      return {
        ...state,
        campaign: {
          ...state.campaign,
          ...action.payload.value,
        },
      };
    }
    case ADD_URL_PARAMETERS_FROM_COOKIE_HISTORY: {
      return {
        ...state,
        campaignFromCookies: action.payload.value,
      };
    }
    default:
      return state;
  }
}
